export default __webpack_public_path__ + "static/8-3704810521b3302a78c3a22663b53dfe.jpg";